import styled from "styled-components";

export const InputCustom = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  margin: 13px 0;
  input {
    width: 100%;
    max-width: 610px;
    height: 50px;
    background-color: ${(props) => props.theme.background.white}fff;
    border-radius: 16.0779px;
    padding: 0px 32px;
    display: inline-block;
    box-sizing: border-box;
    text-align: left;
    border: none;
    font-family: "Poppins";
    font-style: normal;
    font-weight: 400;
    font-size: 15px;
    line-height: 143.2%;
    color: ${(props) => props.theme.color.default};
    ::-webkit-input-placeholder {
      color: #a7a7a7;
    }
    :focus {
      outline: 0;
    }
    @media (max-width: 768px) {
      height: 40px;
      font-size: 13px;
      line-height: 143.2%;
      padding: 0px 20px;
      border-radius: 9.59402px;
    }
  }
`;
